'use client';
import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { CategoryWithArticlesAndSubCategories } from '@dr-pam/common-components/Services/Server/CategoryService';
import { ResourceCategoryWithResource } from '@dr-pam/common-components/Services/Server/ResourceService';

interface ExtendedCategory extends CategoryWithArticlesAndSubCategories {
	categoryResources?: ResourceCategoryWithResource[];
}

interface CategoryListProps {
	categories: ExtendedCategory[];
	programmeName: string;
}

export default function CategoryList({ categories, programmeName }: CategoryListProps) {
	const [selectedCategory, setSelectedCategory] = useState<ExtendedCategory | null>(null);
	const router = useRouter();

	const handleCategoryClick = (category: ExtendedCategory) => {
		setSelectedCategory(selectedCategory?.id === category.id ? null : category);
	};

	const handleSubCategoryClick = (category: ExtendedCategory, subCategory: ExtendedCategory) => {
		router.push(`/free-resources/${category.slug}/${subCategory.slug}`);
	};

	const topLevelCategories = categories.sort((a, b) => a.sortOrder - b.sortOrder);

	return (
		<>
			<h1>{programmeName}</h1>
			<ul className="free-resource-list">
				{topLevelCategories.map((category) => (
					<li className="resource-categories" key={category.id}>
						<a onClick={() => handleCategoryClick(category)}>
							<b>{category.name}</b>
						</a>
						{selectedCategory?.id === category.id && category.subCategories && (
							<ul className="resource-subcategories">
								{category.subCategories
									.sort((a, b) => a.sortOrder - b.sortOrder)
									.map((subCategory) => (
										<li className="title" key={subCategory.id}>
											<a onClick={() => handleSubCategoryClick(category, subCategory)}>
												{subCategory.name}
											</a>
										</li>
									))}
							</ul>
						)}
					</li>
				))}
			</ul>
		</>
	);
}
